
// @codekit-prepend "../bower_components/foundation-sites/dist/js/foundation.min.js"
// @codekit-prepend  "../bower_components/waypoints/lib/jquery.waypoints.min.js"

$(document).foundation();

//smooth scroll

$('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
    // On-page links
    if ( location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname ) {

        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

        // Does a scroll target exist?
        if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 1000, function() {
                // Callback after animation
                // Must change focus!
                var $target = $(target);
                $target.focus();
                if ($target.is(":focus")) { // Checking if the target was focused
                    return false;
                } else {
                    $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                    $target.focus(); // Set focus again
                }
            });
        }
    }
});

$(window).scroll(function(){
    $("#hero").css("opacity", 1 - $(window).scrollTop() / 300);
});

// $.each(['section'], function(i, classname) {
//     var $elements = $('.' + classname);

//     $elements.each(function() {
//         new Waypoint({
//             element: this,
//             handler: function(direction) {
//                 var previousWaypoint = this.previous();
//                 var nextWaypoint = this.next();
//                 var sectionColor = $(this.element).attr('data-color');

//                 $elements.removeClass('np-previous np-current np-next');
//                 $('body').removeClass();
//                 $(this.element).addClass('np-current');
//                 $('body').addClass(sectionColor);

//                 if (previousWaypoint) {
//                     $(previousWaypoint.element).addClass('np-previous');
//                 }
//                 if (nextWaypoint) {
//                     $(nextWaypoint.element).addClass('np-next');
//                 }
//             },
//             offset: '50%',
//             //group: classname
//         });
//     });
// });


// Waypoints.js
// var $waypoints = document.querySelectorAll('.section');

// $waypoints.forEach(($waypoint) => {
//     new Waypoint({
//         offset: '10%',
//         element: $waypoint,
//         handler: function(direction) {

//             if (direction === 'down') {
//                 document.querySelectorAll('nav li a').forEach((e) => e.classList.remove('active'));
//                 document.querySelectorAll('nav li a[data-section='+this[0, 'element'].id+']').forEach((e) => e.classList.add('active'));
//             }
//         }
//     });

//     new Waypoint({
//         offset: -$waypoint.offsetHeight+'px',
//         element: $waypoint,
//         handler: function(direction) {
//             if (direction === 'up') {
//                 console.log($waypoint.offsetHeight);
//                 document.querySelectorAll('nav li a').forEach((e) => e.classList.remove('active'));
//                 document.querySelectorAll('nav li a[data-section='+this[0, 'element'].id+']').forEach((e) => e.classList.add('active'));
//             }
//         }
//     });
// });


$('.section').each(function () {
    var $waypoint = $(this)[0]; // [0] gets object

    new Waypoint({
        offset: '50%',
        element: $waypoint,
        handler: function (direction) {

            if (direction === 'down') {
                var sectionColor = $(this.element).attr('data-color');

                $('.section').removeClass('is-active');

                $('body').removeClass();

                $(this.element).addClass('is-active');
                $('body').addClass(sectionColor);

                // console.log(this.element.id + ' hit');
            }
        }
    });

    new Waypoint({
        offset: function () {
            return Waypoint.viewportHeight() / 2 - this.element.clientHeight;
        },
        element: $waypoint,
        handler: function (direction) {
            if (direction === 'up') {
                // console.log($waypoint.offsetHeight);
                var sectionColor = $(this.element).attr('data-color');

                $('.section').removeClass('is-active');
                $('body').removeClass();

                $(this.element).addClass('is-active');
                $('body').addClass(sectionColor);

                // console.log(this.element.id + ' hit');
            }
        }
    });
});


// Social Media Share
// Creates small window popups for social media sharing, except for email
$('.social__link:not(.social__link--email)').click(function(ev){
    var url = $(this).attr('href');

    // open popup
    window.open(url,'Social','width=500,height=400,resizable=yes,scrollbars=yes,titlebar=yes');

    ev.preventDefault();
    return false;
});
